import { render } from "./BarcodePDFLayout.vue?vue&type=template&id=0bc7dea4&scoped=true"
import script from "./BarcodePDFLayout.vue?vue&type=script&lang=ts"
export * from "./BarcodePDFLayout.vue?vue&type=script&lang=ts"

import "./BarcodePDFLayout.vue?vue&type=style&index=0&id=0bc7dea4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0bc7dea4"

export default script